
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/world/2024/speakers",
      function () {
        return require("private-next-pages/world/2024/speakers.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/world/2024/speakers"])
      });
    }
  